import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_VEHICLE_MAKE = createActionTypes('FETCH_VEHICLE_MAKE');
export const GET_VEHICLE_MAKE = createActionTypes('GET_VEHICLE_MAKE_MAKE');
export const CREATE_VEHICLE_MAKE = createActionTypes('CREATE_VEHICLE_MAKE');
export const UPDATE_VEHICLE_MAKE = createActionTypes('UPDATE_VEHICLE_MAKE');
export const DELETE_VEHICLE_MAKE = createActionTypes('DELETE_VEHICLE_MAKE');
